import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { GET_FIELD_REGISTRY, GET_FIELD_REGISTRY_SUCCESS, GET_FIELD_REGISTRY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getFieldRegistry({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/field-registry`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: GET_FIELD_REGISTRY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_FIELD_REGISTRY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FIELD_REGISTRY_ERROR, payload: error });
  }
}

export function* watchgetFieldRegistry() {
  yield takeEvery(GET_FIELD_REGISTRY, getFieldRegistry);
}

function* getFieldRegistrySaga() {
  yield all([fork(watchgetFieldRegistry)]);
}

export default getFieldRegistrySaga;
